import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { AxiosResponse } from "axios"
import { authApi } from "../instances";
import { ANALYSIS_PATHS, UTILS_PATHS } from "../paths/index.paths";
import { ConvertDataToGetParams } from "../../utils/ConvertDataToGetParams";
import { TemplateSheetGetRes, TemplateSheetReq, TemplateSheetRes, TemplateSheetGetReq } from "../../types/api/categories.api.types";



export class TemplatesApi{
        static async CreateNewAnalysisTemplate(req: TemplateSheetReq): Promise<AxiosResponse<TemplateSheetRes>> {
        const res: AxiosResponse<TemplateSheetRes> = await authApi.post(ANALYSIS_PATHS.CREATE_TEMPLATE_SHEET, req);
        if (!res.data) {
            throw res
        }
        return res
    }

    static async GetAnalysisTemplate(req: TemplateSheetGetReq): Promise<AxiosResponse<TemplateSheetGetRes>> {
        const res: AxiosResponse<TemplateSheetGetRes> = await authApi.get(`${ANALYSIS_PATHS.GET_TEMPLATES}${ConvertDataToGetParams(req)}`);
        if (!res.data) {
            throw res
        }
        return res
    }

    static async DelAnalysisTemplate(req: TemplateSheetGetReq): Promise<AxiosResponse<TemplateSheetGetRes>> {
        const res: AxiosResponse<TemplateSheetGetRes> = await authApi.post(UTILS_PATHS.DEL_TEMPLATE, req);
        if (!res.data) {
            throw res
        }
        return res
    }

    static async GetTemplateByName(req: TemplateSheetGetReq): Promise<AxiosResponse<TemplateSheetGetRes>> {
        const res: AxiosResponse<TemplateSheetGetRes> = await authApi.get(`${ANALYSIS_PATHS.GET_TEMPLATES}${ConvertDataToGetParams(req)}`);
        if (!res.data) {
            throw res
        }
        return res
    }
}